import React from "react";

// fetchSendInvitations.js - API functions for sending event invitations

const API_URL = process.env.REACT_APP_API_URL || 'https://localhost:7204';

export const sendInvitations = async (buildingId, eventName, dateTime) => {
    try {
        const response = await fetch(`${API_URL}/api/Approvers/SendEventInvitations`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}` // Add if you use JWT tokens
            },
            body: JSON.stringify({
                BuildingId: buildingId.toString(), // Convert to string and use PascalCase
                EventName: eventName,
                DateTime: dateTime
            })
        });

        if (!response.ok) {
            // Try to get error message from response
            const errorText = await response.text();
            throw new Error(errorText || `HTTP error! status: ${response.status}`);
        }

        // Check if the response is JSON
        const contentType = response.headers.get('Content-Type');
        if (!contentType || !contentType.includes('application/json')) {
            const text = await response.text();
            throw new Error('Server returned non-JSON response');
        }

        return await response.json();
    } catch (err) {
        
        // Provide more specific error messages
        if (err.message.includes('404')) {
            throw new Error('API endpoint not found. Please check if the backend server is running.');
        } else if (err.message.includes('Failed to fetch')) {
            throw new Error('Cannot connect to the server. Please check if the backend is running.');
        } else {
            throw err;
        }
    }
};